	// --- Compteur JS pour filtres actifs hors disponibilité ---
	// Fonction utilitaire pour compter dynamiquement les filtres actifs hors disponibilité
	// Cette fonction lit les paramètres de l'URL, compte tous les filtres actifs
	// sauf filter.v.availability=1 (qui est appliqué par défaut et ne doit pas être compté)


	function updateActiveFiltersCount() {
		// Récupère les paramètres de l'URL
		const params = new URLSearchParams(window.location.search);

		let activeCount = 0;
		params.forEach((value, key) => {
			// On ne compte que les filtres commençant par "filter."
			// et on exclut explicitement filter.v.availability=1
			if (
				key.startsWith('filter.') &&
				!(key === 'filter.v.availability' && value === '1')
			) {
				// Si le filtre a plusieurs valeurs (séparées par des virgules), on les compte toutes
				// Gère les valeurs multiples (ex: filter.v.option.taille=XS,S)
				if (value.includes(',')) {
					activeCount += value.split(',').length;
				} else {
					activeCount += 1;
				}
			}
		});

		// Met à jour le DOM
		document.querySelectorAll('[data-facets-actives] .active-filters-count').forEach(el => {
			if (activeCount > 0) {
				el.textContent = `(${activeCount})`;  // Affiche le nombre de filtres actifs
				el.classList.remove('u-hidden'); // Affiche le compteur si au moins un filtre est actif
			} else {
				el.textContent = '';  // Vide le compteur si aucun filtre actif
				el.classList.add('u-hidden'); // Cache le compteur
			}
		});
	}

	class FacetFiltersForm extends HTMLElement {
		constructor() {
			super();
			this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

			this.debouncedOnSubmit = debounce((event) => {
				this.onSubmitHandler(event);
			}, 500);

			const facetForm = this.querySelector('form');
			facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
		}

		static setListeners() {
			const onHistoryChange = (event) => {
				const searchParams = event.state ?
					event.state.searchParams :
					FacetFiltersForm.searchParamsInitial;
				if (searchParams === FacetFiltersForm.searchParamsPrev) return;
				FacetFiltersForm.renderPage(searchParams, null, false);
			};
			window.addEventListener('popstate', onHistoryChange);
		}

		static toggleActiveFacets(disable = true) {
			document.querySelectorAll('[data-facets-remove]').forEach((element) => {
				element.classList.toggle('disabled', disable);
			});
		}

		static renderPage(searchParams, event, updateURLHash = true) {
			FacetFiltersForm.searchParamsPrev = searchParams;
			const sections = FacetFiltersForm.getSections();

			sections.forEach((section) => {
				const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
				const filterDataUrl = (element) => element.url === url;

				FacetFiltersForm.filterData.some(filterDataUrl) ?
					FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
					FacetFiltersForm.renderSectionFromFetch(url, event);
			});

			if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
		}

		static renderSectionFromFetch(url, event) {
			fetch(url)
				.then((response) => response.text())
				.then((responseText) => {
					const html = responseText;
					FacetFiltersForm.filterData = [
						...FacetFiltersForm.filterData,
						{
							html,
							url
						},
					];
					FacetFiltersForm.renderFilters(html, event);
					FacetFiltersForm.renderProductGridContainer(html);
					FacetFiltersForm.renderProductCount(html);
					FacetFiltersForm.renderEraseFilters(html);
				});
		}

		static renderSectionFromCache(filterDataUrl, event) {
			const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
			FacetFiltersForm.renderFilters(html, event);
			FacetFiltersForm.renderProductGridContainer(html);
			FacetFiltersForm.renderProductCount(html);
			FacetFiltersForm.renderEraseFilters(html);

		}

		static renderProductGridContainer(html) {
			document.querySelector('[data-facets-products-grid]').innerHTML =
				new DOMParser()
				.parseFromString(html, 'text/html')
				.querySelector('[data-facets-products-grid]').innerHTML;

			let grid = document.querySelector('[data-facets-products-grid]')
			document.dispatchEvent(new CustomEvent('grid:updated', {detail: {container: grid}}));
		}


		static renderProductCount(html) {
			const parser = new DOMParser();
			const parsedHtml = parser.parseFromString(html, 'text/html');

			// Get and format count from new HTML
			const count = parsedHtml.querySelector('[data-facets-count]').innerHTML;
			const countValue = parseInt(count, 10);
			const countText = `${countValue} ${countValue <= 1 ? window.collectionFacets?.product : window.collectionFacets?.products }`;

			// Replace visible count
			const countStart = document.querySelector('[data-facet-count-start]');
			const countNew = document.querySelectorAll('[data-facets-count]');

			if (countStart) {
				countStart.classList.add('u-hidden');
			}

			countNew.forEach(container => {
				container.innerHTML = countText;
				container.classList.remove('u-hidden');
			});

			// --- Compteur panel (Voir x produits) ---
			const newPanelNode = parsedHtml.querySelector('[data-facets-count-panel]');
			const newPanelValue = parseInt(newPanelNode?.innerHTML || '0', 10);
			const panelText = `${newPanelValue} ${newPanelValue <= 1 ? window.collectionFacets?.product : window.collectionFacets?.products }`;

			const oldPanelNode = document.querySelector('[data-facet-count-panel-start]');
			if (oldPanelNode) {
				oldPanelNode.classList.add('u-hidden');
			}

			const visiblePanelNode = document.querySelector('[data-facets-count-panel]');
			if (visiblePanelNode) {
				visiblePanelNode.innerHTML = panelText;
				visiblePanelNode.classList.remove('u-hidden');
			}
		}

		static renderFilters(html, event) {
			const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

			const facetDetailsElements = parsedHTML.querySelectorAll(
				'[data-facets-form] [data-facets-filter]',
			);
			const matchesIndex = (element) => {
				const jsFilter = event ?
					event.target.closest('[data-facets-filter]') :
					undefined;
				return jsFilter ?
					element.dataset.index === jsFilter.dataset.index :
					false;
			};
			const facetsToRender = Array.from(facetDetailsElements).filter(
				(element) => !matchesIndex(element),
			);
			facetsToRender.forEach((element) => {
				document.querySelector(
					`[data-index="${element.dataset.index}"]`,
				).innerHTML = element.innerHTML;
			});

			FacetFiltersForm.renderActiveFacets(parsedHTML);
		}

		static renderActiveFacets(html) {
			const activeFacetElementSelectors = ['[data-facets-actives]'];

			activeFacetElementSelectors.forEach((selector) => {
				const activeFacetsElement = html.querySelector(selector);
				if (!activeFacetsElement) return;
				document.querySelector(selector).innerHTML =
					activeFacetsElement.innerHTML;
			});

			FacetFiltersForm.toggleActiveFacets(false);
		}

		static renderEraseFilters(html) {
			const eraseFilters = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-erase-filters]').innerHTML
			const container = document.querySelector('[data-erase-filters]');
			container.innerHTML = eraseFilters;

		}


		static updateURLHash(searchParams) {
			history.pushState({
					searchParams
				},
				'',
				`${window.location.pathname}${searchParams && '?'.concat(searchParams)}`,
			);
		}

		static getSections() {
			return [{
				section: document.querySelector('[data-facets-product-grid]').dataset
					.id,
			}, ];
		}

		createSearchParams(form) {
			// const formData = new FormData(form);
			// return new URLSearchParams(formData).toString();

			const formData = new FormData(form);
			let newSearchParams = new URLSearchParams(formData).toString();
			if ((newSearchParams.includes("filter.v.option") || newSearchParams.includes("filter.p.m")) && !newSearchParams.includes("filter.v.availability")) {
				newSearchParams = newSearchParams + "&filter.v.availability=1";
			}
			return newSearchParams;

		}

		onSubmitForm(searchParams, event) {
			FacetFiltersForm.renderPage(searchParams, event);
		}

		onSubmitHandler(event) {
			event.preventDefault();
			const sortFilterForms = document.querySelectorAll(
				'facet-filters-form form',
			);
			const forms = [];

			sortFilterForms.forEach((form) => {
				if (form.id === 'FacetFiltersForm') {
					forms.push(this.createSearchParams(form));
				}
			});
			this.onSubmitForm(forms.join('&'), event);
		}

		onActiveFilterClick(event) {
			event.preventDefault();
			FacetFiltersForm.toggleActiveFacets();
			const url =
				event.currentTarget.href.indexOf('?') == -1 ?
				'' :
				event.currentTarget.href.slice(
					event.currentTarget.href.indexOf('?') + 1,
				);
			FacetFiltersForm.renderPage(url);
		}


	}

	FacetFiltersForm.filterData = [];
	FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
	FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
	customElements.define('facet-filters-form', FacetFiltersForm);
	FacetFiltersForm.setListeners();


// On met à jour le compteur JS à chaque navigation (popstate) ou changement de filtre (événement custom)

	window.addEventListener('popstate', updateActiveFiltersCount);
	document.addEventListener('facet:updated', updateActiveFiltersCount);

// Appel initial au chargement de la page pour afficher le bon compteur dès le départ
	updateActiveFiltersCount();

	class PriceRange extends HTMLElement {
		constructor() {
			super();
			this.querySelectorAll('input').forEach((element) =>
				element.addEventListener('change', this.onRangeChange.bind(this)),
			);
			this.setMinAndMaxValues();
		}

		onRangeChange(event) {
			this.adjustToValidValues(event.currentTarget);
			this.setMinAndMaxValues();
		}

		setMinAndMaxValues() {
			const inputs = this.querySelectorAll('input');
			const minInput = inputs[0];
			const maxInput = inputs[1];
			if (maxInput.value) minInput.setAttribute('max', maxInput.value);
			if (minInput.value) maxInput.setAttribute('min', minInput.value);
			if (minInput.value === '') maxInput.setAttribute('min', 0);
			if (maxInput.value === '')
				minInput.setAttribute('max', maxInput.getAttribute('max'));
		}

		adjustToValidValues(input) {
			const value = Number(input.value);
			const min = Number(input.getAttribute('min'));
			const max = Number(input.getAttribute('max'));

			if (value < min) input.value = min;
			if (value > max) input.value = max;
		}
	}

	customElements.define('price-range', PriceRange);

	class FacetRemove extends HTMLElement {
		constructor() {
			super();
			const facetLink = this.querySelector('a');
			facetLink.setAttribute('role', 'button');
			facetLink.addEventListener('click', this.closeFilter.bind(this));
			facetLink.addEventListener('keyup', (event) => {
				if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
			});
		}

		closeFilter(event) {
			event.preventDefault();
			const form = this.closest('facet-filters-form');
			form.onActiveFilterClick(event);
		}
	}

	customElements.define('facet-remove', FacetRemove);